import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Paper,
  Box,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useSelector } from "react-redux";
import { investorApi } from "../../../api/api";
import { useNavigate } from "react-router-dom";
import GradientButton from "../../common/GradiantButton";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";


export default function AddBankDetails() {
  const id = useSelector((state) => state.user.userId);
  const navigate = useNavigate();
  const theme = useSelector((data) => data.themeValue.colors);
  const themeMode = useSelector((data) => data.themeValue.theme);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });


  const [bankData, setBankData] = useState({
    PaymentType: "BankAccount",
    AccountHolderName: "",
    AccountNumber: "",
    Branch: "",
    BankName: "",
    IFSCCode: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };


  const handleInputChange = (e) => {
    setBankData({ ...bankData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setSubmitError("");
  };

  const validate = () => {
    const newErrors = {};

    if (!bankData.AccountHolderName.trim()) {
      newErrors.AccountHolderName = "Account holder name is required.";
    }

    if (!bankData.AccountNumber.trim()) {
      newErrors.AccountNumber = "Account number is required.";
    }
    //  else if (!/^\d{9,18}$/.test(bankData.AccountNumber)) {
    //   newErrors.AccountNumber = "Account number must be 9 to 18 digits.";
    // }

    if (!bankData.BankName.trim()) {
      newErrors.BankName = "Bank name is required.";
    }

    if (!bankData.Branch.trim()) {
      newErrors.Branch = "Branch name is required.";
    }

    if (!bankData.IFSCCode.trim()) {
      newErrors.IFSCCode = "IFSC code is required.";
    } 
    // else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(bankData.IFSCCode.toUpperCase())) {
    //   newErrors.IFSCCode = "Invalid IFSC code format.";
    // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }

    setLoading(true);
    try {
      const response = await investorApi.addBankDetails(id, bankData);
      if (response.status === 201) {
        showSnackbar("Bank details added successfully!", "success");
        navigate("/");

      }
    } catch (error) {

      setSubmitError(
        error.response?.data?.error || "Failed to add bank details."
      );
      showSnackbar("Failed to .", "error");

    } finally {
      setLoading(false);
    }
  };



  return (
    <Container sx={{ mt: 5, width: "100%" }}>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 3,
          backgroundColor: theme.background,
          boxShadow:
            themeMode === "light"
              ? "0px 4px 12px rgba(0, 0, 0, 0.15)"
              : "0px 4px 12px rgba(255, 255, 255, 0.1)",
        }}
      >

        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.text }}>
          Add Bank Details
        </Typography>

        {submitError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submitError}
          </Alert>
        )}

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Account Holder Name"
            name="AccountHolderName"
            value={bankData.AccountHolderName}
            onChange={handleInputChange}
            error={!!errors.AccountHolderName}
            helperText={errors.AccountHolderName}
            fullWidth
            sx={{
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />
          <TextField
            label="Account Number"
            name="AccountNumber"
            value={bankData.AccountNumber}
            onChange={handleInputChange}
            error={!!errors.AccountNumber}
            helperText={errors.AccountNumber}
            fullWidth
            inputProps={{ inputMode: "numeric" }}
            sx={{
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />
          <TextField
            label="Bank Name"
            name="BankName"
            value={bankData.BankName}
            onChange={handleInputChange}
            error={!!errors.BankName}
            helperText={errors.BankName}
            fullWidth
            sx={{
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />
          <TextField
            label="Branch"
            name="Branch"
            value={bankData.Branch}
            onChange={handleInputChange}
            error={!!errors.Branch}
            helperText={errors.Branch}
            fullWidth
            sx={{
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />
          <TextField
            label="IFSC Code"
            name="IFSCCode"
            value={bankData.IFSCCode}
            onChange={handleInputChange}
            error={!!errors.IFSCCode}
            helperText={errors.IFSCCode}
            fullWidth
            inputProps={{ style: { textTransform: "uppercase" } }}
            sx={{
              input: {
                color: theme.text,
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color,
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text,
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color,
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color,
                },
              },
            }}
          />
        </Box>

        <Box display="flex" justifyContent="center" mt={3}>
          <GradientButton text={loading ? <CircularProgress size={24} /> : "Save"}
            width="100%"
            onClick={handleSubmit} />
        </Box>
      </Paper>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>

    </Container>
  );
}
